(function (globalScope, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (globalScope && globalScope.document) {
    globalScope.MnEngagement = api;
    api.init(globalScope.document, globalScope);
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  // Convites úteis (sem cupom, roleta ou urgência): especialista na PDP e lembrete discreto de carrinho.
  const SESSION_KEY = 'mn_session_seen';
  const SPECIALIST_KEY = 'mn_specialist_shown';
  const RECOVERY_KEY = 'mn_recovery_shown';
  const BLOCKED_PAGES = ['cart', 'checkout'];
  const DAY_MS = 864e5;
  const RETRY_MS = 10000;
  const MAX_RETRIES = 2;
  const RECOVERY_DELAY_MS = 1500;
  const MIN_DWELL_SECONDS = 5;
  const KEYBOARD_VIEWPORT_RATIO = 0.75;
  // Quem chega de anúncio social (utm_medium=paid_social) vê o convite só depois de 60 s, para não cobrir o botão de compra.
  const PAID_SOCIAL_KEY = 'mn_paid_social';
  const PAID_SOCIAL_MIN_DWELL_SECONDS = 60;

  function storageFor(windowRoot, kind) {
    try { return kind === 'day' ? windowRoot.localStorage : windowRoot.sessionStorage; } catch { return null; }
  }

  function consentAllowed(windowRoot) {
    try {
      const privacy = windowRoot.Shopify && windowRoot.Shopify.customerPrivacy;
      return !!(privacy && typeof privacy.preferencesProcessingAllowed === 'function' && privacy.preferencesProcessingAllowed() === true);
    } catch { return false; }
  }

  function storageKind(windowRoot, frequency) {
    return frequency === 'day' && consentAllowed(windowRoot) ? 'day' : 'session';
  }

  function wasShown(windowRoot, key, frequency) {
    if (frequency === 'always') return false;
    const kind = storageKind(windowRoot, frequency);
    const storage = storageFor(windowRoot, kind);
    try {
      const raw = storage && storage.getItem(key);
      if (!raw) return false;
      if (kind === 'session') return true;
      const at = Number(raw);
      return Number.isFinite(at) && Date.now() - at < DAY_MS;
    } catch { return false; }
  }

  function markShown(windowRoot, key, frequency) {
    if (frequency === 'always') return;
    const storage = storageFor(windowRoot, storageKind(windowRoot, frequency));
    try { if (storage) storage.setItem(key, String(Date.now())); } catch { /* memória apenas */ }
  }

  function arrivedFromPaidSocial(windowRoot) {
    let search = '';
    try { search = String((windowRoot.location && windowRoot.location.search) || ''); } catch { search = ''; }
    const fromUrl = /(?:^|[?&])utm_medium=paid_social(?:&|$)/i.test(search);
    const storage = storageFor(windowRoot, 'session');
    try {
      if (fromUrl && storage) storage.setItem(PAID_SOCIAL_KEY, '1');
      return fromUrl || !!(storage && storage.getItem(PAID_SOCIAL_KEY));
    } catch { return fromUrl; }
  }

  function isFirstPageOfSession(windowRoot) {
    const storage = storageFor(windowRoot, 'session');
    try {
      if (!storage) return true;
      if (storage.getItem(SESSION_KEY)) return false;
      storage.setItem(SESSION_KEY, '1');
      return true;
    } catch { return true; }
  }

  function keyboardLikelyOpen(documentRoot, windowRoot) {
    // Teclado virtual encolhe o visualViewport; quando ele existe, é o sinal confiável (desktop nunca bloqueia).
    const viewport = windowRoot.visualViewport;
    if (viewport && windowRoot.innerHeight) return viewport.height < windowRoot.innerHeight * KEYBOARD_VIEWPORT_RATIO;
    let coarse = false;
    try { coarse = !!(windowRoot.matchMedia && windowRoot.matchMedia('(pointer: coarse)').matches); } catch { coarse = false; }
    const active = documentRoot.activeElement;
    return coarse && !!active && /^(INPUT|TEXTAREA|SELECT)$/.test(String(active.tagName || ''));
  }

  function otherDialogOpen(documentRoot, own) {
    const open = documentRoot.querySelectorAll('dialog[open]');
    for (let index = 0; index < open.length; index += 1) if (open[index] !== own) return true;
    return false;
  }

  function buildWhatsappText(config, documentRoot) {
    const product = config.product || {};
    const form = documentRoot.querySelector('form[action*="/cart/add"]');
    const input = form && form.querySelector('input[name="id"]');
    const variantId = input ? String(input.value || '') : '';
    const variant = product.variants && product.variants[variantId];
    const sku = (variant && variant.sku) || product.sku || '';
    const variantTitle = variant && variant.title && variant.title !== 'Default Title' ? variant.title : '';
    let text = `Olá! Vim pelo site da MakNorte e quero falar com um especialista sobre: ${product.title || 'um produto'}`;
    if (sku) text += ` (SKU ${sku}${variantTitle ? `, ${variantTitle}` : ''})`;
    if (product.url) text += ` — ${product.url}`;
    return text;
  }

  function buildWhatsappHref(config, documentRoot) {
    const number = String(config.whatsapp || '').replace(/\D/g, '');
    return `https://wa.me/${number}?text=${encodeURIComponent(buildWhatsappText(config, documentRoot))}`;
  }

  function openInvite(element, documentRoot) {
    if (!element) return false;
    const previous = documentRoot && documentRoot.activeElement;
    try {
      if (typeof element.show === 'function' && !element.open) element.show();
      else element.open = true;
    } catch { element.open = true; }
    element.hidden = false;
    // Convite não modal: nunca rouba o foco de quem está comprando (dialog.show() move o foco por padrão).
    const active = documentRoot && documentRoot.activeElement;
    const stolen = active && typeof element.contains === 'function' ? element.contains(active) : active === element;
    if (stolen) {
      if (typeof active.blur === 'function') active.blur();
      const body = documentRoot.body;
      if (previous && previous !== active && previous !== body && typeof previous.focus === 'function') previous.focus({ preventScroll: true });
    }
    return true;
  }

  function closeInvite(element) {
    if (!element) return;
    try {
      if (typeof element.close === 'function' && element.open) element.close();
      else element.open = false;
    } catch { element.open = false; }
    element.hidden = true;
  }

  function init(documentRoot, windowRoot) {
    if (documentRoot.documentElement.dataset.mnEngagementReady === 'true') return;
    documentRoot.documentElement.dataset.mnEngagementReady = 'true';
    const config = windowRoot.MNEngagement || {};
    const pageType = config.pageType || 'other';
    const specialist = Object.assign({ enabled: false, delaySeconds: 30, frequency: 'session' }, config.specialist || {});
    const recovery = Object.assign({ enabled: false, frequency: 'session' }, config.recovery || {});
    const specialistEl = documentRoot.querySelector('[data-mn-specialist-dialog]');
    const recoveryEl = documentRoot.querySelector('[data-mn-cart-recovery]');
    const pathname = String((windowRoot.location && windowRoot.location.pathname) || '');
    const blocked = BLOCKED_PAGES.indexOf(pageType) >= 0 || /\/checkouts?(\/|$)/.test(pathname);
    const firstPage = isFirstPageOfSession(windowRoot);
    let recoveryVisible = false;
    let specialistShown = false;
    let retries = 0;

    if (recoveryEl && recovery.enabled && !blocked && Number(config.cartCount) > 0 && firstPage && !wasShown(windowRoot, RECOVERY_KEY, recovery.frequency)) {
      windowRoot.setTimeout(() => {
        if (otherDialogOpen(documentRoot, null)) return;
        recoveryVisible = openInvite(recoveryEl, documentRoot);
        markShown(windowRoot, RECOVERY_KEY, recovery.frequency);
      }, RECOVERY_DELAY_MS);
    }

    const canShowSpecialist = () => !!specialistEl && specialist.enabled === true && pageType === 'product' && !blocked
      && !specialistShown && !wasShown(windowRoot, SPECIALIST_KEY, specialist.frequency);

    const tryShowSpecialist = (reason) => {
      if (!canShowSpecialist()) return false;
      if (recoveryVisible || otherDialogOpen(documentRoot, specialistEl) || keyboardLikelyOpen(documentRoot, windowRoot)) {
        if (retries < MAX_RETRIES) {
          retries += 1;
          windowRoot.setTimeout(() => tryShowSpecialist(reason), RETRY_MS);
        }
        return false;
      }
      const link = specialistEl.querySelector('[data-mn-specialist-whatsapp]');
      if (link) link.href = buildWhatsappHref(config, documentRoot);
      specialistShown = openInvite(specialistEl, documentRoot);
      if (specialistEl.dataset) specialistEl.dataset.mnReason = reason;
      markShown(windowRoot, SPECIALIST_KEY, specialist.frequency);
      return specialistShown;
    };

    if (canShowSpecialist()) {
      const baseDwellSeconds = Math.max(MIN_DWELL_SECONDS, Number(specialist.delaySeconds) || 30);
      const dwellSeconds = arrivedFromPaidSocial(windowRoot) ? Math.max(baseDwellSeconds, PAID_SOCIAL_MIN_DWELL_SECONDS) : baseDwellSeconds;
      windowRoot.setTimeout(() => tryShowSpecialist('dwell'), dwellSeconds * 1000);
      const freightMessage = documentRoot.querySelector('[data-mv2-cep-msg]');
      if (freightMessage && typeof windowRoot.MutationObserver === 'function') {
        const observer = new windowRoot.MutationObserver(() => {
          const isError = !freightMessage.hidden && freightMessage.classList && freightMessage.classList.contains('mv2-cep__msg--error');
          if (isError && tryShowSpecialist('freight_error')) observer.disconnect();
        });
        observer.observe(freightMessage, { attributes: true, childList: true });
      }
    }

    documentRoot.addEventListener('click', (event) => {
      const target = event.target && typeof event.target.closest === 'function' ? event.target : null;
      if (!target) return;
      if (target.closest('[data-mn-recovery-dismiss]')) { closeInvite(recoveryEl); recoveryVisible = false; }
      if (target.closest('[data-mn-specialist-dismiss]')) closeInvite(specialistEl);
    });

    documentRoot.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (specialistEl && specialistEl.open) closeInvite(specialistEl);
      if (recoveryVisible) { closeInvite(recoveryEl); recoveryVisible = false; }
    });
  }

  return { init, buildWhatsappHref, buildWhatsappText, wasShown, markShown, keyboardLikelyOpen };
});
